function validateDefinition(identifier, handler) {
  if (typeof identifier !== "string" || !identifier.trim() || typeof handler !== "function") throw new TypeError("BackgroundTasks.defineTask requires an identifier and handler");
}
function validateSubmission(identifier, earliestBeginDateMs) {
  if (!identifier.trim()) throw new TypeError("BackgroundTasks.submit requires an identifier");
  if (earliestBeginDateMs !== void 0 && (!Number.isFinite(earliestBeginDateMs) || earliestBeginDateMs < 0)) throw new RangeError("BackgroundTasks.submit earliestBeginDateMs must be a timestamp");
}
function validateCancellation(identifier) {
  if (!identifier.trim()) throw new TypeError("BackgroundTasks.cancel requires an identifier");
}
export {
  validateCancellation,
  validateDefinition,
  validateSubmission
};
//# sourceMappingURL=validate.js.map
